// extracted by mini-css-extract-plugin
export default {"mCard":"aC-z","image":"bC-z","imageNoBackground":"cC-z","imageHasCategory":"dC-z","fullWidth":"eC-z"};